import Vue from "vue";
import Tip from "./tip.vue";
import Loading from "./loading.vue";

let loadvm;
export default {
    tip:(message)=>{
        const constructor = Vue.extend({
            render(h){
                return h(Tip,{props:{message}});
            },
        });
        const vm = new constructor().$mount();
        document.body.appendChild(vm.$el);
    },
    loading:()=>{
        if(!loadvm){
            const constructor = Vue.extend(Loading);
            loadvm = new constructor().$mount();
            document.body.appendChild(loadvm.$el);
        }
    },
    unload:()=>{
        if(loadvm){
            loadvm.isShow=false;
            loadvm=null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/message/index.js